var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandsetCws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#060605;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,25.5c1.3-1.3,5-5,8.3-8.3L49,36.2c-2.3,2.3-5.2,5.2-7.5,7.5c-6.3,6.3-6.3,16.5,0,22.8l33.9,33.9 c6.3,6.3,16.5,6.3,22.8,0c2.3-2.3,5.2-5.2,7.5-7.5l18.9,18.9c-3.3,3.3-7,7.1-8.3,8.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-2.4,2.3-7.7,6-16.3,4.8c-4.3-0.6-13.2-2.3-24.2-7.4c-11.2-5.1-21.4-12.2-30.3-21c-8.8-8.9-15.9-19.1-21-30.3 c-5.1-11.1-6.8-19.9-7.4-24.2c-1.2-8.6,2.5-14,4.8-16.4C21.6,25.8,21.7,25.7,21.8,25.5 M13,16.8c-0.2,0.2-0.4,0.4-0.5,0.5 c-5,5.1-9.9,14.1-8.2,26.6c1.9,14.1,9.9,39.3,31.9,61.6c22.3,22,47.5,30,61.6,31.9c12.5,1.7,21.5-3.2,26.7-8.2 c0.1-0.1,0.2-0.2,0.5-0.4c1.9-1.9,8.7-8.7,11.8-11.9c2.9-2.9,2.9-7.5,0-10.4l-26-26c-2.8-2.8-7.3-2.9-10.2-0.2 c-0.1,0.1-11.3,11.3-11.3,11.3c-1.4,1.4-3.8,1.4-5.2,0L50.3,57.7c-1.4-1.4-1.4-3.8,0-5.2c0,0,11.2-11.2,11.3-11.3 c2.7-2.9,2.6-7.4-0.2-10.2l-26-26c-2.9-2.9-7.5-2.9-10.4,0C21.8,8.1,14.9,14.9,13,16.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsetCws);
export default __webpack_public_path__ + "static/media/handsetCWS.5c09dba2a7a7bf05007b358228640c3e.svg";
export { ForwardRef as ReactComponent };